import * as busyCounter from '../../../sharedmodules/action-creators/busy-counter';
import { createSuccessMessage } from '../../../sharedmodules/action-creators/alert-messages';
import { deleteAdminNotification } from '../repositories/deleteNotifications';
import { readNotificationData } from './read-notification';
import { translate } from '../../../sharedmodules/services/translation-service';

export const deleteNotification = (getAccessToken, id) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());
    try {

        await deleteAdminNotification(getAccessToken, id);
        dispatch(readNotificationData(getAccessToken));
        dispatch(createSuccessMessage(translate('NOTIFICATION_DELETED_SUCCESSFULLY')));

    } catch (error) {

        dispatch(readNotificationData(getAccessToken));
        throw (error);

    } finally {

        setTimeout(() => {

            dispatch(busyCounter.decreaseBusyCounter());

        }, 200);

    }

};
